import React, { useState } from 'react';
import { Calendar, dateFnsLocalizer, Views } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import { enUS } from 'date-fns/locale';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import './Dashboard.css';
import MobileNav from '../defaultLayout/MobileNav';
import CustomToolbar from './CustomToolbar'; // Import your custom toolbar component
import Select from 'react-select'

// Sample events with additional fields
const myEventsList = [
  // Single Event
  {
    ROWID: '12345678',
    title: 'Meeting with Team A',
    start: new Date(2024, 8, 5, 10, 0), // September 5, 2024, 10:00 AM
    end: new Date(2024, 8, 5, 11, 0), // September 5, 2024, 11:00 AM
    site: 'Site A',
    job: 'Job A',
    location: 'Location A'
  },
  {
    ROWID: '12345679',
    title: 'Lunch with Sarah',
    start: new Date(2024, 8, 6, 12, 0), // September 6, 2024, 12:00 PM
    end: new Date(2024, 8, 6, 13, 0), // September 6, 2024, 1:00 PM
    site: 'Site B',
    job: 'Job B',
    location: 'Location B'
  },
  {
    ROWID: '12345680',
    title: 'Project Deadline',
    start: new Date(2024, 8, 10, 17, 0), // September 10, 2024, 5:00 PM
    end: new Date(2024, 8, 10, 18, 0), // September 10, 2024, 6:00 PM
    site: 'Site C',
    job: 'Job C',
    location: 'Location C'
  },

  // Multiple Events on September 7, 2024
  [
    {
      ROWID: '12345680',
      title: 'Project Deadline',
      start: new Date(2024, 8, 13, 17, 0), // September 10, 2024, 5:00 PM
      end: new Date(2024, 8, 13, 18, 0), // September 10, 2024, 6:00 PM
      site: 'Site C',
      job: 'Job C',
      location: 'Location C'
    },
    {
      ROWID: '12345680',
      title: 'Project Deadline',
      start: new Date(2024, 8, 14, 17, 0), // September 14, 2024, 5:00 PM
      end: new Date(2024, 8, 14, 18, 0), // September 14, 2024, 6:00 PM
      site: 'Site C',
      job: 'Job C',
      location: 'Location C'
    }, {
      ROWID: '12345680',
      title: 'Project Deadline',
      start: new Date(2024, 8, 15, 17, 0), // September 15, 2024, 5:00 PM
      end: new Date(2024, 8, 15, 18, 0), // September 15, 2024, 6:00 PM
      site: 'Site C',
      job: 'Job C',
      location: 'Location C'
    },
    {
      ROWID: '12345680',
      title: 'Project Deadline',
      start: new Date(2024, 8, 16, 17, 0), // September 16, 2024, 5:00 PM
      end: new Date(2024, 8, 16, 18, 0), // September 16, 2024, 6:00 PM
      site: 'Site C',
      job: 'Job C',
      location: 'Location C'
    }
  ],

  // Multiple Events on September 8, 2024
  ...Array.from({ length: 10 }, (_, i) => ({
    ROWID: `20240908-${i}`,
    title: `Event ${i + 1}`,
    start: new Date(2024, 8, 8, i % 12 + 8, (i * 15) % 60), // Random time on September 8, 2024
    end: new Date(2024, 8, 8, (i % 12 + 8) + 1, (i * 15 + 30) % 60), // 1 hour later
    site: `Site ${i % 3 + 1}`,
    job: `Job ${i % 3 + 1}`,
    location: `Location ${i % 3 + 1}`
  })),

  // Single Event for Variety
  {
    ROWID: '12345681',
    title: 'Client Call',
    start: new Date(2024, 8, 12, 14, 0), // September 12, 2024, 2:00 PM
    end: new Date(2024, 8, 12, 15, 0), // September 12, 2024, 3:00 PM
    site: 'Site D',
    job: 'Job D',
    location: 'Location D'
  },

  // Another Event for More Variety
  {
    ROWID: '12345682',
    title: 'Office Party',
    start: new Date(2024, 8, 29, 19, 0), // September 15, 2024, 7:00 PM
    end: new Date(2024, 8, 29, 22, 0), // September 15, 2024, 10:00 PM
    site: 'Site E',
    job: 'Job E',
    location: 'Location E'
  }
];
const employeeList = [
  { name: "John Doe", position: "Manager", salary: "₹890.12" },
  { name: "Jane Smith", position: "Developer", salary: "₹890.12" },
  { name: "Emily Johnson", position: "Designer", salary: "₹890.12" },
  { name: "Michael Brown", position: "Tester", salary: "₹890.12" },
  { name: "Sarah Davis", position: "Analyst", salary: "₹890.12" },
  { name: "Chris Wilson", position: "HR", salary: "₹890.12" },
  { name: "Patricia Taylor", position: "Accountant", salary: "₹890.12" },
  { name: "James Anderson", position: "Support", salary: "₹890.12" },
  { name: "Linda Martinez", position: "Admin", salary: "₹890.12" },
  { name: "Robert Hernandez", position: "Sales", salary: "₹890.12" },
  { name: "Barbara Lewis", position: "Marketing", salary: "₹890.12" },
  { name: "William Walker", position: "Developer", salary: "₹890.12" },
  { name: "Elizabeth Hall", position: "Designer", salary: "₹890.12" },
  { name: "David Wright", position: "Manager", salary: "₹890.12" },
  { name: "Mary Young", position: "Analyst", salary: "₹890.12" },
  // Add more employees as needed
]

// Localizer configuration
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales: { 'en-US': enUS },
});
const customStyle = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: state.isFocused ? 'silver' : 'rgb(93, 135, 255)',
    border: '0.5px solid rgb(196,196,196,0.5) !important',
    borderRadius: '20px',
    zIndex: 9999
  }),
}
const Dashboard = (newSidebarColor, newNavbarColor, newTextColor, navbarTextColor, cardColor) => {
  const [events, setEvents] = useState(myEventsList);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isNewEvent, setIsNewEvent] = useState(false);
  const [showMobileNav, setShowMobileNav] = useState(true);

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    setIsNewEvent(false);
  };

  const handleSelectSlot = ({ start, end }) => {
    // Prepare new event object with default values
    setSelectedEvent({
      ROWID: `new-${Date.now()}`, // Unique ID for the new event
      start,
      end,
      job: '',
      site: '',
      location: '',
    });
    setIsNewEvent(true);
  };

  const handleClosePopup = () => {
    setSelectedEvent(null);
    setIsNewEvent(false);
  };

  const handleInputChange = (e, field) => {
    setSelectedEvent((prevEvent) => ({
      ...prevEvent,
      [field]: e.target.value,
    }));
  };

  const handleSaveChanges = () => {
    if (isNewEvent) {
      // Add new event to the list
      setEvents((prevEvents) => [...prevEvents, selectedEvent]);
    } else {
      // Update existing event
      setEvents((prevEvents) =>
        prevEvents.map((event) =>
          event.ROWID === selectedEvent.ROWID ? selectedEvent : event
        )
      );
    }
    handleClosePopup();
  };

  // Format dates for input fields
  const formatDate = (date) => {
    return date ? format(date, "yyyy-MM-dd'T'HH:mm") : '';
  };
  const employeeList1 = [
    { value: 'peter', label: 'peter' },
    { value: 'somya', label: 'somya' },
    { value: 'shobhnath', label: 'shobhnath' },
    { value: 'jaishikha', label: 'jaishikha' },
  ]
  return (
    <>
      <Tabs>
        <TabList>
          <Tab>Dashboard</Tab>

          {/* <Tab>Job Scheduling</Tab>q
          <Tab>Time sheet</Tab> */}
          {/* <Tab>All Scheduled Jobs</Tab> */}
        </TabList>
        <TabPanels>
          <TabPanel className="scrollable-content">
            <div className="container-fluid" style={{ fontSize: '15px;', }}>
              <div className="row">
                <div className="col-md-4 mb-2 p-2" style={{ color: '#92D1B4' }} >
                  <div className="card shadow-sm  h-100" style={{ height: '70px', padding: '0.0em', borderRadius: '7px' }}>
                    <div className="card-body d-flex flex-column p-0" style={{ color: '#1f4956' }}>
                      <h5 className="card-title ps-2 pt-1  backgroundcolor1" style={{ fontSize: '13px;', backgroundColor: '#cae1d8;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }}><b>Today's Due Task : Deal</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff;' }}>
                        <span style={{ fontWeight: '600' }}>Task Owner (Tasks)</span>
                        <span style={{ fontWeight: '600' }}>Record Count</span>
                      </div>
                      <div className="flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;', }}>
                        <div className="d-flex justify-content-between  border-bottom px-2 px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Shashi Saini</span>
                          <span>15</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>31</span>
                        </div>
                      </div>
                      <div className="border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>93</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: "#f27d7d" }}>
                  <div className="card shadow-sm  h-100" style={{ height: '70px', padding: '0.0em', borderRadius: '7px' }}>
                    <div className="card-body d-flex flex-column p-0" style={{ color: "#f27d7d" }}>
                      <h5 className="card-title ps-2 pt-1 backgroundcolor2" style={{ fontSize: '13px;', backgroundColor: '#fce7e7;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }}><b>Overdue Due Tasks : Deal</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff;' }}>
                        <span className="font-weight-bold ">Task Owner (Tasks)</span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className="flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;', }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Kritika Saini</span>
                          <span>2</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Shashi Saini</span>
                          <span>15</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>31</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Vinod Kumar</span>
                          <span>45</span>
                        </div>

                      </div>
                      <div className="border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>93</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: '#25618a' }}>
                  <div className="card shadow-sm  h-100" style={{ height: '70px;', padding: '0.0em', borderRadius: '7px' }}>
                    <div className="card-body d-flex flex-column p-0" style={{ color: '#25618a' }}>
                      <h5 className="card-title ps-2 pt-1 backgroundcolor3 color3" style={{ fontSize: '13px;', backgroundColor: '#c7e9ff;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }}><b>This Week Due Tasks : Deal</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff;' }}>
                        <span style={{ fontWeight: '600' }} >Task Owner (Tasks)</span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className="flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;', }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Shashi Saini</span>
                          <span>1</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Sunder Singh</span>
                          <span>1</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Kritika Saini</span>
                          <span>2</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>3</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Vinod Kumar</span>
                          <span>2</span>
                        </div>

                      </div>
                      <div className="border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span cla>Total</span>
                          <span style={{ paddingRight: '26px;' }}>7</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: '#92D1B4' }}>
                  <div className="card shadow-sm h-100" style={{ height: '70px;', padding: '0.0em', borderRadius: '7px' }} >
                    <div className="card-body d-flex flex-column p-0" style={{ color: '#1f4956' }}>

                      <h5 className="card-title ps-2 pt-1 backgroundcolor1" style={{ fontSize: '13px;', backgroundColor: '#cae1d8;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }} ><b>Today's Due Task : Lead</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff;' }}>
                        <span style={{ fontWeight: '600' }} >Task Owner (Tasks)</span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className=" flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;' }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>2</span>
                        </div>
                      </div>
                      <div className="border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>2</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: '#f27d7d' }}>
                  <div className="card shadow-sm  h-100" style={{ height: '70px;', padding: '0.0em', borderRadius: '7px' }}>
                    <div className="card-body d-flex flex-column p-0" style={{ color: "#f27d7d" }}>
                      <h5 className="card-title ps-2 pt-1 backgroundcolor2" style={{ fontSize: '13px;', backgroundColor: '#fce7e7;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }}><b>Overdue Tasks : Lead</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff' }}>
                        <span style={{ fontWeight: '600' }} >Task Owner (Tasks)</span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className="flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;' }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Kritika Saini</span>
                          <span>2</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Sunder Singh</span>
                          <span>15</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>31</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Vinod Kumar</span>
                          <span>45</span>
                        </div>

                      </div>
                      <div className="border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>568</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: '#25618a' }}>
                  <div className="card shadow-sm h-100" style={{ height: '70px;', padding: '0.0em', borderRadius: '7px' }}>
                    <div className="card-body d-flex flex-column p-0" style={{ color: '#25618a' }}>
                      <h5 className="card-title ps-2 pt-1 backgroundcolor3 color3" style={{ fontSize: '13px;', backgroundColor: '#c7e9ff;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }}><b>This Week Due Tasks : Lead</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff', }}>
                        <span style={{ fontWeight: '600' }} >Task Owner (Tasks)</span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className="flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;' }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Sunder Singh</span>
                          <span>1</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>9</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Vinod Kumar</span>
                          <span>6</span>
                        </div>

                      </div>
                      <div className="border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>7</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: '#1f4956' }}>
                  <div className="card shadow-sm  h-100" style={{ height: '70px;', padding: '0.0em', borderRadius: '7px' }}>
                    <div className="card-body d-flex flex-column p-0" style={{ color: '#1f4956' }}>

                      <h5 className="card-title ps-2 pt-1 backgroundcolor1" style={{ fontSize: '13px;', backgroundColor: '#cae1d8;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }} ><b>Today's Due Task : All Tasks</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff', }}>
                        <span style={{ fontWeight: '600' }} >Task Owner (Tasks)</span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className="flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;' }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>3</span>
                        </div>
                      </div>
                      <div className="m-2 border-top p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>3</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: '#f27d7d' }}>
                  <div className="card shadow-sm h-100" style={{ height: '70px;', padding: '0.0em', borderRadius: '7px' }}>
                    <div className="card-body d-flex flex-column p-0" style={{ color: "#f27d7d" }}>
                      <h5 className="card-title ps-2 pt-1 backgroundcolor2" style={{ fontSize: '13px;', backgroundColor: '#fce7e7;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }} ><b>Overdue Tasks : All Tasks</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff', }}>
                        <span style={{ fontWeight: '600' }} >Task Owner (Tasks)</span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className="flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;' }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Balvinder Singh</span>
                          <span>1</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 " style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Kritika Saini</span>
                          <span>4</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 " style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>281</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 " style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>15</span>
                        </div>
                      </div>
                      <div className=" border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>20</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: '#25618a' }}>
                  <div className="card shadow-sm  h-100" style={{ height: '70px;', padding: '0.0em', borderRadius: '7px' }}>
                    <div className="card-body d-flex flex-column p-0" style={{ color: '#25618a' }}>
                      <h5 className="card-title ps-2 pt-1 backgroundcolor3 color3" style={{ fontSize: '13px;', backgroundColor: '#c7e9ff;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }}><b>This Week Due Tasks : All Tasks</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff' }}>
                        <span style={{ fontWeight: '600' }} >Task Owner (Tasks)</span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className="flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;' }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Sunder Singh</span>
                          <span>1</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Balvinder Singh</span>
                          <span>1</span>
                        </div>
                      </div>
                      <div className="border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>2</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: '#1f4956' }}>
                  <div className="card shadow-sm  h-100" style={{ height: '70px;', padding: '0.0em', borderRadius: '7px' }} >
                    <div className="card-body d-flex flex-column p-0" style={{ color: '#1f4956' }}>
                      <h5 className="card-title ps-2 pt-1 backgroundcolor1" style={{ fontSize: '13px;', backgroundColor: '#cae1d8;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }} > <b>Lead Owner</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff', }}>
                        <span style={{ fontWeight: '600' }} >Lead Owner </span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className=" flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;' }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Balvinder Singh</span>
                          <span>2</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Kritika Saini</span>
                          <span>36</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Sunder Singh</span>
                          <span>14</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>650</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Vinod Kumar</span>
                          <span>268</span>
                        </div>

                      </div>
                      <div className="border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>970</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: '#f27d7d' }}>
                  <div className="card shadow-sm  h-100" style={{ height: '70px;', padding: '0.0em', borderRadius: '7px' }}>
                    <div className="card-body d-flex flex-column p-0" style={{ color: "#f27d7d" }}>
                      <h5 className="card-title ps-2 pt-1 backgroundcolor2" style={{ fontSize: '13px;', backgroundColor: '#fce7e7;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }} ><b>Source Wise:: Leads</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff;', }}>
                        <span style={{ fontWeight: '600' }} >Lead Source</span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className="flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;' }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Z-P Customer's</span>
                          <span>6</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 " style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Zoholics</span>
                          <span>31</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 " style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Zoho Team: Direct</span>
                          <span>281</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 " style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Cold Call</span>
                          <span>16</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 " style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Employee Referral</span>
                          <span>1</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 " style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>External Referral</span>
                          <span>10</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 " style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Zoho Marketplace</span>
                          <span>5</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2 " style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Linkdin</span>
                          <span>1</span>
                        </div>
                      </div>
                      <div className=" border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>970</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-2 p-2" style={{ color: '#25618a' }}>
                  <div className="card shadow-sm  h-100" style={{ height: '70px;', padding: '0.0em', borderRadius: '7px' }}>
                    <div className="card-body d-flex flex-column p-0" style={{ color: '#25618a' }}>
                      <h5 className="card-title ps-2 pt-1 backgroundcolor3 color3" style={{ fontSize: '13px;', backgroundColor: '#c7e9ff;', height: '30px;', textAlign: 'left', borderRadius: '7px 7px 0 0' }} ><b>Deal Owner</b></h5>
                      <div className="d-flex justify-content-between border-bottom pb-1 bg-light rounded mx-2 px-2" style={{ paddingLeft: '5px;', paddingRight: '5px;', backgroundColor: '#f8faff;', }}>
                        <span style={{ fontWeight: '600' }} >Deal Owner</span>
                        <span style={{ fontWeight: '600' }} >Record Count</span>
                      </div>
                      <div className="flex-grow-1 scrollable px-2" style={{ maxHeight: '116px;' }}>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Jonny Saini</span>
                          <span>1</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Kritika Saini</span>
                          <span>4</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Shashi Saini</span>
                          <span>20</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Sunder Singh</span>
                          <span>2</span>
                        </div>
                        <div className="d-flex justify-content-between  border-bottom px-2" style={{ paddingLeft: '6px;', paddingRight: '30px;' }}>
                          <span>Utkarsh Hazaria</span>
                          <span>54</span>
                        </div>
                      </div>
                      <div className="border-top mx-2 p-2">
                        <div className="d-flex justify-content-between">
                          <span style={{ fontWeight: '600' }}>Total</span>
                          <span style={{ paddingRight: '26px;' }}>177</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>

          {/* <TabPanel>
            <div className='row'>
              <div className='col-lg-3 pe-0' style={{ borderRight: "1px solid rgb(231 231 224)" }}>
                <div className="walletBalanceCard">
                  <div className='d-flex gap-2 w-100 pt-1 align-items-center'>
                    <div className="balancewrapper ps-2">
                      <p className="balance mb-0">Employees</p>
                    </div>
                  </div>
                </div>
                <div style={{ overflow: 'scroll', maxHeight: '80vh' }}>
                  {employeeList.map((employee, index) => (
                    <div className="walletBalanceCard" key={index}>
                      <div className='d-flex gap-2 w-100 pt-1 align-items-center'>
                        <div className="svgwrapper">
                          <input type="checkbox" />
                        </div>
                        <div className="balancewrapper ps-2">
                          <p className="balance mb-0">{employee.name}</p>
                          <span className="balanceHeading">Position: {employee.position}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className='col-lg-9'>
                <div>
                  <div style={{ height: 500 }}>
                    <Calendar
                      localizer={localizer}
                      events={events}
                      startAccessor="start"
                      endAccessor="end"
                      style={{ height: '100%', backgroundColor: '#fff' }}
                      onSelectEvent={handleSelectEvent}
                      selectable
                      onSelectSlot={handleSelectSlot}
                      components={{ toolbar: CustomToolbar }}
                      popup={true}
                      maxRows={4} // Added line
                      allDayAccessor='allDayEvent'
                      dayLayoutAlgorithm='no-overlap' // Changed line
                      defaultView='month'
                      onShowMore={(events, date) => {
                        console.log(events, date);
                      }}
                      eventPropGetter={(event) => ({
                        style: {
                          backgroundColor: 'lightblue',
                          color: '#fff',
                          borderRadius: '5px',
                          border: '1px solid rgba(196,196,196,0.5)',
                          fontSize: '0.75rem',
                        }
                      })}
                    />
                  </div>
                  {selectedEvent && (
                    <div style={{ ...popupStyles.overlay, zIndex: 9999 }}>
                      <div style={popupStyles.container}>
                        <div className="col-md-12 align-items-stretch">
                          <div className="card card-detail p-0" style={{ border: 'none' }}>
                            <div className="card-body py-0 px-0">
                              <div className="table-responsive">
                                <table className="table table-space">
                                  <tbody>
                                    <tr className='tr-border text-start'>
                                      <th className='font-weight table-space pe-5'>Job Name</th>
                                      <td className='font-color ps-5'>
                                        <input
                                          type="text"
                                          value={selectedEvent.job}
                                          onChange={(e) => handleInputChange(e, 'job')}
                                          style={inputStyles}
                                          placeholder='Job Name'
                                        />
                                      </td>
                                    </tr>
                                    <tr className='tr-border text-start'>
                                      <th className='font-weight table-space pe-5'>Site Name</th>
                                      <td className='font-color ps-5'>
                                      <Select options={employeeList1} isMulti className='w-100' styles={customStyle}/>  
                                        
                                      </td>
                                    </tr>
                                    <tr className='tr-border text-start'>
                                      <th className='font-weight table-space pe-5'>Location</th>
                                      <td className='font-color ps-5'>
                                        <input
                                          type="text"
                                          value={selectedEvent.location}
                                          onChange={(e) => handleInputChange(e, 'location')}
                                          style={inputStyles}
                                          placeholder='Location'
                                        />
                                      </td>
                                    </tr>
                                    <tr className='tr-border text-start'>
                                      <th className='font-weight table-space pe-5'>Start Date & Time</th>
                                      <td className='font-color ps-5'>
                                        <input
                                          type="datetime-local"
                                          value={formatDate(new Date(selectedEvent.start))}
                                          onChange={(e) => handleInputChange(e, 'start')}
                                          style={inputStyles}

                                        />
                                      </td>
                                    </tr>
                                    <tr className='tr-border text-start'>
                                      <th className='font-weight table-space pe-5'>End Date & Time</th>
                                      <td className='font-color ps-5'>
                                        <input
                                          type="datetime-local"
                                          value={formatDate(new Date(selectedEvent.end))}
                                          onChange={(e) => handleInputChange(e, 'end')}
                                          style={inputStyles}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='d-flex gap-2 justify-content-center'>
                          <button className='cancel-button px-4' onClick={handleClosePopup}>
                            Close
                          </button>
                          <button className='save-button px-4' onClick={handleSaveChanges}>
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <p>three!</p>
          </TabPanel> */}
          {/* <TabPanel>
            <div>
              <div style={{ height: 500 }}>
                <Calendar
                  localizer={localizer}
                  events={events}
                  startAccessor="start"
                  endAccessor="end"
                  style={{ height: '100%', backgroundColor: '#fff' }}
                  onSelectEvent={handleSelectEvent}
                  selectable
                  onSelectSlot={handleSelectSlot}
                  components={{ toolbar: CustomToolbar }}
                  popup={true}
                  allDayMaxRows={4}
                  defaultView='month'
                  dayLayoutAlgorithm='no-overlap'
                />
              </div>
              {selectedEvent && (
                <div style={{ ...popupStyles.overlay, zIndex: 9999 }}>
                  <div style={popupStyles.container}>
                    <div className="col-md-12 align-items-stretch">
                      <div className="card card-detail p-0" style={{ border: 'none' }}>
                        <div className="card-body py-0 px-0">
                          <div className="table-responsive">
                            <table className="table table-space">
                              <tbody>
                                <tr className='tr-border text-start'>
                                  <th className='font-weight table-space pe-5'>Job Name</th>
                                  <td className='font-color ps-5'>
                                    <input
                                      type="text"
                                      value={selectedEvent.job}
                                      onChange={(e) => handleInputChange(e, 'job')}
                                      style={inputStyles}
                                      placeholder='Job Name'
                                    />
                                  </td>
                                </tr>
                                <tr className='tr-border text-start'>
                                  <th className='font-weight table-space pe-5'>Site Name</th>
                                  <td className='font-color ps-5'>
                                      <Select options={employeeList1} isMulti className='w-100' styles={customStyle}/>       
                                  </td>
                                </tr>
                                <tr className='tr-border text-start'>
                                  <th className='font-weight table-space pe-5'>Location</th>
                                  <td className='font-color ps-5'>
                                    <input
                                      type="text"
                                      value={selectedEvent.location}
                                      onChange={(e) => handleInputChange(e, 'location')}
                                      style={inputStyles}
                                      placeholder='Location'
                                    />
                                  </td>
                                </tr>
                                <tr className='tr-border text-start'>
                                  <th className='font-weight table-space pe-5'>Start Date & Time</th>
                                  <td className='font-color ps-5'>
                                    <input
                                      type="datetime-local"
                                      value={formatDate(new Date(selectedEvent.start))}
                                      onChange={(e) => handleInputChange(e, 'start')}
                                      style={inputStyles}

                                    />
                                  </td>
                                </tr>
                                <tr className='tr-border text-start'>
                                  <th className='font-weight table-space pe-5'>End Date & Time</th>
                                  <td className='font-color ps-5'>
                                    <input
                                      type="datetime-local"
                                      value={formatDate(new Date(selectedEvent.end))}
                                      onChange={(e) => handleInputChange(e, 'end')}
                                      style={inputStyles}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='d-flex gap-2 justify-content-center'>
                      <button className='cancel-button px-4' onClick={handleClosePopup}>
                        Close
                      </button>
                      <button className='save-button px-4' onClick={handleSaveChanges}>
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </TabPanel> */}
        </TabPanels>
      </Tabs>

      {showMobileNav && (
        <div className='d-block d-sm-block d-lg-none d-md-none'>
          <MobileNav />
        </div>
      )}
    </>
  );
};

const popupStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    background: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
  },
};

const inputStyles = {
  border: 'none',
  outline: 'none',
  padding: '4px',
  width: '100%',
  boxSizing: 'border-box',
};

export default Dashboard;
